import { Center } from '@chakra-ui/react';
import { datadogLogs } from '@datadog/browser-logs';
import { LoadingState } from '@main/complykit';
import { backofficeDrawerSchema } from '@main/shared/utils';
import { useAuthenticationStatus, useUserData } from '@nhost/react';
import { createRoute, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

import { SignIn } from '../../features/user/signin';
import SidebarAuthenticatedLayout from '../../layouts/sidebar-authenticated';
import { rootRoute } from '../__root';

export const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'auth',
  component: Auth,
  validateSearch: backofficeDrawerSchema,
});

function Auth() {
  const { isLoading, isAuthenticated } = useAuthenticationStatus();
  const userData = useUserData();
  const userRoles = userData?.roles || [];
  const isAdmin = userRoles.includes('admin');
  const userId = userData?.id;

  const isCurrentPathRoot = useRouterState({ select: ({ location }) => location.pathname === '/' });

  useEffect(() => {
    if (userId) {
      datadogLogs.setUser({ id: userId });
    }
  }, [userId]);

  if (isLoading) {
    return (
      <Center h="100vh">
        <LoadingState />
      </Center>
    );
  }

  if (!isAuthenticated || !isAdmin) {
    return <SignIn />;
  }

  if (isCurrentPathRoot) {
    return <Navigate to="/home" replace />;
  }

  return (
    <SidebarAuthenticatedLayout>
      <Outlet />
    </SidebarAuthenticatedLayout>
  );
}
